const numberFormatter = new Intl.NumberFormat('fr-CA', {
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
})

export const formatListingPrice = (price: string | number, currency = '$') => {
  const parsedPrice =
    typeof price === 'number'
      ? price
      : Number(String(price).replace(',', '.').replace(/[^\d.-]/g, ''))

  const formattedPrice = Number.isFinite(parsedPrice)
    ? numberFormatter.format(parsedPrice)
    : String(price)

  const normalizedCurrency = currency === 'CAD' ? '$' : currency || '$'

  return `${formattedPrice} ${normalizedCurrency} / mois`
}
